import { MMB, CKI } from '@/utils/constants/rip'

export const MESSAGE_MAX_CHARACTERS = 4500

export const BOOKING_VERIFICATION_FORM_TYPES = [MMB, CKI] as const
export type BookingVerificationFormType = (typeof BOOKING_VERIFICATION_FORM_TYPES)[number]
